import {BDCPBookmarksModule} from '../bookmarks/bookmarks.module';
import {BDCPFilterModule} from '../filter/filter.module';
import {BDCPMasterDetailMasterComponent} from './pages/master/master.page';
import {BDCPMasterDetailRoutingModule} from './master-detail-routing.module';
import {BDCPProductDetailsModule} from '../product-details/product-details.module';
import {BDCPProductFinderModule} from '../product-finder/product-finder.module';
import {BDCPSharedModule} from '../shared/shared.module';
import {BDSharedModule} from '@brother-apps/brother-dealerapp-shared-lib';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BDSharedModule,
        BDCPFilterModule,
        BDCPSharedModule,
        BDCPProductFinderModule,
        BDCPProductDetailsModule,
        BDCPBookmarksModule,

        BDCPMasterDetailRoutingModule
    ],
    declarations: [
        BDCPMasterDetailMasterComponent,
    ],
    exports: [
        BDCPMasterDetailMasterComponent,
    ],
    providers: []
})
export class BDCPMasterDetailModule {
}
